import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ParkComponent } from './park/park.component';
import { ParkRoutingModule } from './park-routing.module';
import { MatCardModule } from "@angular/material/card";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { PipesModule } from "../../helpers/pipes/pipes.module";
import { CampaignService } from '../private-campaign/services/campaign.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ScreenLocationService } from "../private-campaign/services/screenLocation.service";
import { FaceService, FilteredFaceDetailsParams } from "../private-campaign/services/face.service";
import { ScreenDetailsComponent } from './screen-details/screen-details.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSliderModule } from '@angular/material/slider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { FilterModule } from '../filter/filter.module';
import { MatChipsModule } from '@angular/material/chips';
import { CrudModule } from '../../helpers/crud/crud.module';
import { SpotsModule } from '../spots/spots.module';
import { ScreenParametersComponent } from './screen-parameters/screen-parameters/screen-parameters.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { ScreenInfoComponent } from './screen-info/screen-info.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { WncmScreenFilterComponent } from '../../helpers/others/wncm-screen-filter/wncm-screen-filter.component';


@NgModule({
    declarations: [ParkComponent, ScreenDetailsComponent, ScreenParametersComponent],
    imports: [
        CommonModule,
        ParkRoutingModule,
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        MatMenuModule,
        MatDialogModule,
        DragDropModule,
        PipesModule,
        MatProgressSpinnerModule,
        InfiniteScrollModule,
        MatCheckboxModule,
        MatSliderModule,
        MatFormFieldModule,
        MatOptionModule,
        MatChipsModule,
        MatSelectModule,
        FilterModule,
        MatChipsModule,
        CrudModule,
        SpotsModule,
        MatExpansionModule,
        ScreenInfoComponent,
        GoogleMapsModule,
        WncmScreenFilterComponent
    ],
    providers: [
        ScreenLocationService,
        FaceService,
        FilteredFaceDetailsParams,
        CampaignService,
        DatePipe
    ],
})
export class ParkModule { }
